import React from 'react'
import { ToCartCommonComponent } from '../to_cart_common/to_cart_common.component'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'
import { sharedData } from '../../../models/shared_data'

export class ToCartThumbComponent extends ToCartCommonComponent {

  render() {
    const it = this.props.params
    const price = this.currentPrice()
    const symbol = sharedData.currency_symbol

    if(this.state.inCart > 0)
      return (
        <div className="item-thumb__price">
          <div className="item-show-price item-show-price--no-padding">
            <div className="item-show-price-incart">
              <div className="item-show-price-incart__wrapper">
                <a className="down" href="" onClick={this.down}>-</a>
                <span className="item-show-price-incart__count">
                  {this.state.quantity}
                </span>
                <a className="up" href="" onClick={this.up} style={this.firstOrderUsed() ? { opacity: 0.3, cursor: 'default' } : null}>+</a>
              </div>
              <div className="item-thumb__cart-btn">
                <a className="btn btn--mini"
                  href="/cart"
                  >К корзине</a>
              </div>
              { this.firstOrderUsed() && this.firstOrderNote() }
            </div>
          </div>
        </div>
      )

    return (
      <div>
        <div className="item-thumb__price">
          { this.needUnitsInfo() &&
            <div className="item-thumb__price_wrapper">
              <div className="item-thumb__price_one">
              { it.price_one } {symbol}/{ it.price_one_unit }, &nbsp;
              </div>
              <CurFormatComponent price={price}/>

              <span>/{it.price_unit}</span>
            </div>
          }
          { !this.needUnitsInfo() &&
            <CurFormatComponent price={price}/>
          }
          { this.firstOrderUsed() ? this.firstOrderNote() :
            <button className="btn btn--blue btn--mini" onClick={this.toCart}>
              В корзину
            </button>
          }
          <div className="clearfix"></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/to_cart_thumb/to_cart_thumb.component.jsx